import { Container } from 'react-bootstrap';
import { PageLayout } from './components/PageLayout';
import { AuthProvider } from './context/AuthContext';
import { AuthGuard } from './components/AuthGuard';
import { Profile } from './components/Profile';
import { Courses } from './components/Courses';

import './styles/App.css';

const App = () => {
    return (
        <AuthProvider>
            <PageLayout>
                <AuthGuard>
                    <Container className="App">
                        <Profile />
                        <Courses />
                    </Container>
                </AuthGuard>
            </PageLayout>
        </AuthProvider>
    );
};

export default App;